import styled from 'styled-components';
import { Colors, TextStylesDesktop, FiltersTextBtn, FontFamilies } from 'enums';
import { Icon } from '../Icon';

export const TextButtonStyled = styled.button`
  display: flex;
  align-items: center;
  margin-left: auto;
  border: none;
  background-color: transparent;
  max-width: max-content;
  cursor: pointer;
  color: ${Colors.gray2};
  font-size: ${TextStylesDesktop.small1};
  font-family: ${FontFamilies.Inter};

  &:hover {
    color: ${Colors.gray1};
  }
  &:active {
    color: ${Colors.yellow1};
  }
  &:disabled {
    color: ${Colors.gray4};
    cursor: not-allowed;
  }

  &:hover > img {
    filter: ${FiltersTextBtn.gray1};
  }

  &:active > img {
    filter: ${FiltersTextBtn.yellow1};
  }

  &:disabled > img {
    filter: ${FiltersTextBtn.gray4};
    cursor: not-allowed;
  }
`;

export const StyledIcon = styled(Icon)`
  width: 16px;
  height: 16px;
  margin-right: 8px;
  filter: ${FiltersTextBtn.gray2};
`;

export const Text = styled.span`
  display: block;
`;
